import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { JsonFormsModule } from '@jsonforms/angular';

import { StartupSpinnerComponent } from '@plugins/client/spinners';
import { TranslateService } from '@plugins/client/translate/services';
import { setWindowTitleFromJWT } from '@plugins/shared/utils/title-from-jwt';

@Component({
  selector: 'smartforms-root',
  imports: [RouterOutlet, StartupSpinnerComponent, JsonFormsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  protected translateService = inject(TranslateService);
  ngOnInit() {
    setWindowTitleFromJWT();
  }
}
